import {
  UPDATE_GLOBAL_STATE,
} from 'actions';
import { saveKeyToSessionStorage } from 'common/utils/utils';

export const GLOBAL_STATE_SESSION_STORAGE_KEY = 'uniteusGlobalState';

export const defaultState = {
  providers: [],
  employees: [],
  currentEmployee: undefined,
  currentProvider: undefined,
  impersonation: null,
  roles: [],
  intercom: {
    companies: undefined,
    userHash: undefined,
  },
  activeNetworks: [],
  allNetworks: [],
  language: 'en',
  isShoppingCartOpen: false,
};

export default function globalReducer(state = defaultState, action) {
  const {
    type,
    payload,
  } = action;

  switch (type) {
    case UPDATE_GLOBAL_STATE: {
      // reducing the amount of data stored in session storage
      if (payload.providers) {
        payload.providers = payload.providers.map((provider) => {
          const newProvider = {
            ...provider,
          };
          newProvider.user = {
            employee: {
              id: provider.user?.employee?.id,
              provider: {
                id: provider.user?.employee?.provider?.id,
              },
              user: {
                id: provider.user?.employee?.user?.id,
              },
            },
            user: {
              id: provider.user?.user?.id,
              provider: {
                id: provider.user?.user?.provider?.id,
              },
              user: {
                id: provider.user?.user?.user?.id,
              },
            },
          };
          return newProvider;
        });
      }
      if (payload.networkProviders) {
        payload.networkProviders = payload.networkProviders.map((provider) => ({
          id: provider.id,
        }));
      }
      const newState = {
        ...state,
        ...payload,
        intercom: {
          ...state.intercom,
          ...payload.intercom,
        },
      };
      saveKeyToSessionStorage(GLOBAL_STATE_SESSION_STORAGE_KEY, newState);
      return newState;
    }
    default:
      return state;
  }
}
